import { render, staticRenderFns } from "./ImageDialog.vue?vue&type=template&id=63808300&scoped=true&"
import script from "./ImageDialog.vue?vue&type=script&lang=js&"
export * from "./ImageDialog.vue?vue&type=script&lang=js&"
import style0 from "./ImageDialog.vue?vue&type=style&index=0&id=63808300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63808300",
  null
  
)

export default component.exports